var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"hello"},[_c('h1',{staticClass:"intro"},[_vm._v(_vm._s(this.chosenSlogan))])])])}
var staticRenderFns = []

export { render, staticRenderFns }